import { t } from 'i18next';
import { enforce, skipWhen, test } from 'vest';

import { FormUtils } from '@anyx/shared-utils';


import { RichMessageBlock, UploadedImageFile } from '../types';
import { getManualActionURL, isValidActionURL } from '../utils';

export const richMessageValidationBuilder = (index: number) => (message: RichMessageBlock) => {
  test(
    `messages.${index}.image`,
    FormUtils.requiredField(t('crm.lineMessageForm.fields.image.label', { ns: 'crm' })),
    () => {
      enforce(message.image).condition((image?: UploadedImageFile) => image?.state === 'remote');
    },
    `richMessage-${index}-image`
  );

  skipWhen(!getManualActionURL(message.actionUrl), () => {
    test(
      `messages.${index}.actionUrl.manual`,
      t('crm.lineMessageForm.validations.invalidUrl', { ns: 'crm' }),
      () => {
        enforce(getManualActionURL(message.actionUrl)).condition((url) => isValidActionURL(url));
      },
      `richMessage-${index}-actionUrl-manual`
    );
  });
};
